import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';

/**
 * Loads /assets/i18n/<lang>.json and always checks with the server that the copy is current
 * (fetch cache mode "no-cache": the browser sends If-None-Match and gets a small 304 when nothing
 * changed). The files are not content-hashed, and browsers that stored them before nginx sent
 * Cache-Control kept serving old copies, so new keys showed up as raw keys (auth.login.MFA_TITLE).
 */
export class RevalidatingTranslateLoader implements TranslateLoader {
  constructor(private readonly prefix = '/assets/i18n/', private readonly suffix = '.json') {}

  getTranslation(lang: string): Observable<TranslationObject> {
    return from(
      fetch(`${this.prefix}${lang}${this.suffix}`, { cache: 'no-cache' }).then((res) => {
        if (!res.ok) throw new Error(`Could not load translations for "${lang}" (HTTP ${res.status})`);
        return res.json() as Promise<TranslationObject>;
      })
    );
  }
}
